/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiaryMetricDto } from './diaryMetricDto';


export interface DiaryMetricsDto { 
    kcalMetrics?: Array<DiaryMetricDto> | null;
    co2Metrics?: Array<DiaryMetricDto> | null;
}

